import React, { useEffect, useState } from "react";
import "../normalsearch.css";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  userWishListDelete,
  userWishListPost,
} from "../../HttpRequest/applyapplication";
import ProfileShortlisting from "./profileShortListing";
import FoundSomethingWrong from "./Addvancesearch/foundSomethingWrongPopup";
import AreYouLookingForSomeThingElse from "./areYouLockingForSomeThingElsePopup";

export default function ProgramSearch(props) {
  const { searchresult, apply, refreshList } = props;

  const [masterDataId, setMasterDataId] = useState();
  const [loginUserRole, setloginUserRole] = useState("");

  const [data, setdata] = useState();
  const [visible, setVisible] = useState(false);

  const handleApplyClick = (universityId) => {
    console.log("calling-->", universityId);
    apply(universityId);
  };
  const handleOpenModal = () => {
    setVisible(true);
  };

  const history = useHistory();
  const handle = (event, itemId) => {
    event.preventDefault();

    history.push(`/universityapply?data:${itemId}`);
  };

  const universityWishListForUser = (masterId, shortListId) => {
    if (shortListId) {
      userWishListDelete(shortListId).then((response) => {
        console.log("wish list delete--->", response);
        refreshList();
      });
    } else {
      const userId = localStorage.getItem("id");
      let wishObj = {
        masterDataEntityId: masterId,
        userId: userId,
      };
      userWishListPost(wishObj).then((response) => {
        console.log("wish list response--->", response);
        refreshList();
      });
    }
  };
  const [isPopupVisible, setPopupVisible] = useState(false);
  const handleSomethingWrong = (id) => {
    console.log("handleSomethingWrong----->>>>", id);
    setMasterDataId(id);
    setPopupVisible(true);
  };
  const handleCancel = () => {
    setPopupVisible(false);
  };

  const showModal = (applicationId) => {
    setPopupVisible(true);
    setPopupApplicationId(applicationId);
  };

  useEffect(() => {
    if (searchresult != "") {
      console.log("searchresult", searchresult);
      // setPageData(searchresult.metaData)
      // console.log('page data-->', searchresult.metaData)
      setdata(searchresult.data);
    }
    const storedRole = localStorage.getItem("userRole");
    if (storedRole) {
      setloginUserRole(storedRole);
      console.log("role is found-->", loginUserRole);
    } else {
      console.log("role is not found-->");
    }
  }, [searchresult]);
  const hasAccess = (allowedRoles) => allowedRoles.includes(loginUserRole);

  return (
    <div>
      {data?.length === 0 ? (
        <div>No results found</div>
      ) : (
        data?.map((item, index) => {
          var infoString = item.entryRequirements || "";
          var match = infoString.match(/GPA:\s*([0-9]\.[0-9]+)/);

          var gpa = match ? match[1] : "";
          console.log("GPA:", gpa);

          return (
            <>
              <div class="card cardtemplate">
                <div class="card  card11" style={{ height: "100%", width: "100%"  ,borderRadius:'1rem',}}>
                  <img
                    src="https://img.freepik.com/free-vector/young-people-walking-front-college-university-flat-illustration_74855-14224.jpg?w=740&t=st=1699637655~exp=1699638255~hmac=7efda3207831e43577c5984a953c67bc9bd342cc8903b491b61c4ad7a7c6ff99"
                    alt="imag"
                    style={{
                      height: "100%",
                      width: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <div
                  class=" cardtemplatetext"
                  style={{ backgroundColor: "white" }}
                >
                  <div>
                    {/* </div> */}
                    <div
                      className="sameline programsearchmedia"
                      style={{ justifyContent: "space-between" }}
                    >
                      <Link
                        to={{
                          pathname: "/universitydetails",
                          state: { data: item },
                        }}
                      >
                        {" "}
                        <h6 className="coursename">{item.name}</h6>
                      </Link>
                      <div className="sameline normalsameline">
                        {hasAccess(["user"]) && (
                          <h6  className="normalsameline-wishlist1">
                            <div  
                              onClick={() =>
                                universityWishListForUser(
                                  item.id,
                                  item.shortListId
                                )
                              }
                            >
                              <i
                                className={`fa-solid fa-heart${
                                  item.shortList ? " text-danger" : ""
                                }`}
                              ></i>
                            </div>
                          </h6>
                        )}
                        {/* <h6>
                          <i class="fa-solid fa-upload"></i>
                        </h6> */}
                        {hasAccess(["user"]) && (
                          <h6
                            className="programapplybtn"
                            onClick={() => handleApplyClick(item)}
                          >
                            Apply
                          </h6>
                        )}
                        {/* <Link key={index} to={{ pathname: '/universityapply', state: { item } }}>
  <h6 className="programapplybtn">Apply</h6>
</Link> */}
                      </div>
                    </div>
                 

                   
                   <div className="row">

                    <div  className="flex-start-div">
                    <p>
                        <i class="fa-solid fa-building-columns"></i>{" "}
                        {item.university}
                      </p>

                      <p>
                        <i class="fa-solid fa-money-bills"></i> {item.country}
                      </p>
                      <p>
                        <i class="fa-solid fa-building-columns"></i> Intakes :
                        <span style={{ backgroundColor: "whiteSmoke" }}>
                          {" "}
                          <strong> {item.intakes} </strong>
                        </span>{" "}
                      </p>
                    
                      {/* <p>
                        <i class="fa-solid fa-building-columns"></i> Intakes :
                        <span style={{ backgroundColor: "whiteSmoke" }}>
                          {" "}
                          <strong> {item.intakes} </strong>
                        </span>{" "}
                      </p> */}

<div    
                      style={{ color: "blue", cursor: "pointer" }}
                      onClick={() => handleSomethingWrong(item.id)}
                    >
                      Found something wrong?
                    </div> 
                    </div>

                    <div  className="flex-start-div">
                    <p>
                        <i class="fa-solid fa-comments-dollar"></i> Yearly
                        Tution Fee :{item.yearlyTuitionFees}{" "}
                        {/* <i class="fa-solid fa-download"></i> */}
                      </p>

                      <p>
                        <i class="fa-solid fa-comments-dollar"></i>{" "}
                        ApplicationFee :
                        <span style={{ backgroundColor: "whiteSmoke" }}>
                          {" "}
                          <strong> {item.applicationFee} </strong>
                        </span>
                      </p>
                      <p>
                        <i class="fa-solid fa-calendar-days"></i> Duration :{" "}
                        {item.duration}
                      </p>
                    </div>
                   </div>
                    {/* <div className="sameline sameline1 programsearchmedia">
                      <p>
                        <i class="fa-solid fa-money-bills"></i> {item.country}
                      </p>
                      <p>
                        <i class="fa-solid fa-comments-dollar"></i>{" "}
                        ApplicationFee :
                        <span style={{ backgroundColor: "whiteSmoke" }}>
                          {" "}
                          <strong> {item.applicationFee} </strong>
                        </span>
                      </p>
                    </div>
                    <div className="sameline sameline1  programsearchmedia">
                      <p>
                        <i class="fa-solid fa-building-columns"></i> Intakes :
                        <span style={{ backgroundColor: "whiteSmoke" }}>
                          {" "}
                          <strong> {item.intakes} </strong>
                        </span>{" "}
                      </p>
                      <p>
                        <i class="fa-solid fa-calendar-days"></i> Duration :{" "}
                        {item.duration}
                      </p>
                    </div> */}
                    {/* <div
                      style={{ color: "blue", cursor: "pointer" }}
                      onClick={() => handleSomethingWrong(item.id)}
                    >
                      Found something wrong?
                    </div> */}
                    <div
                      className="sameline samelinee"
                      style={{ gap: "5px" }}
                    ></div>
                  </div>

<div className="linevertical"></div>
                  <div className="cardbox">
                    {gpa && (
                      <div className="card normalcardbox">
                        <div className="diffline">
                          <p>
                            <strong>GPA </strong>
                          </p>
                          <hr></hr>
                          <p>
                            <strong> {gpa} </strong>
                          </p>
                        </div>
                      </div>
                    )}

                    {item.greScore > 0 && (
                      <div className="card normalcardbox">
                        <div className="diffline">
                          <p>
                            <strong>GRE </strong>
                          </p>
                          <hr></hr>
                          <p>
                            <strong> {item.greScore} </strong>
                          </p>
                        </div>
                      </div>
                    )}

                    {item.ieltsScore > 0 && (
                      <div className="card normalcardbox">
                        <div className="diffline">
                          <p>
                            <strong>IELTS </strong>
                          </p>
                          <hr></hr>
                          <p>
                            <strong> {item.ieltsScore} </strong>
                          </p>
                        </div>
                      </div>
                    )}
                    {item.tofelScore > 0 && (
                      <div className="card normalcardbox">
                        <div className="diffline">
                          <p>
                            <strong>TOEFL </strong>
                          </p>
                          <hr></hr>
                          <p>
                            <strong> {item.tofelScore} </strong>
                          </p>
                        </div>
                      </div>
                    )}

                    {item.detScore > 0 && (
                      <div className="card normalcardbox">
                        <div className="diffline">
                          <p>
                            <strong>DET </strong>
                          </p>
                          <hr></hr>
                          <p>
                            <strong> {item.detScore} </strong>
                          </p>
                        </div>
                      </div>
                    )}
                    {item.pteScore > 0 && (
                      <div className="card normalcardbox">
                        <div className="diffline">
                          <p>
                            <strong>PTE </strong>
                          </p>
                          <hr></hr>
                          <p>
                            <strong> {item.pteScore} </strong>
                          </p>
                        </div>
                      </div>
                    )}
                    {item.gmatScore > 0 && (
                      <div className="card normalcardbox">
                        <div className="diffline">
                          <p>
                            <strong>GMAT </strong>
                          </p>
                          <hr></hr>
                          <p>
                            <strong> {item.gmatScore} </strong>
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          );
        })
      )}
      {hasAccess(["user"]) && isPopupVisible && (
        <FoundSomethingWrong
          isPopupVisible={isPopupVisible}
          masterDataId={masterDataId}  
          handleCancel={handleCancel}
        />
      )}
      <>
        <div className="d-flex" style={{ justifyContent: "space-between" }}>
          {hasAccess(["user"]) && (
            <>
              <AreYouLookingForSomeThingElse />
              <ProfileShortlisting />
            </>
          )}
        </div>
      </>
    </div>
  );
}